/**
 * @function getLastSentAgo
 * @description convert lastSent string date to readable format
 * @param {string} lastSent
 * @returns {string}
 */
export const getLastSentAgo = (lastSent: string): string => {
  if (!lastSent) return 'never'
  const days = Math.round(
    (new Date().getTime() - new Date(lastSent)?.getTime() ||
      new Date().getTime()) /
      (1000 * 60 * 60 * 24),
  )

  if (days > 0) {
    return `${days.toFixed()} day${days > 1 ? 's' : ''} ago`
  }
  const hours = Math.round(
    (new Date().getTime() - new Date(lastSent)?.getTime() ||
      new Date().getTime()) /
      (1000 * 60 * 60),
  )

  if (hours > 0) {
    return `${hours.toFixed()} hour${hours > 1 || hours < 1 ? 's' : ''} ago`
  }

  const minutes = Math.round(
    (new Date().getTime() - new Date(lastSent)?.getTime() ||
      new Date().getTime()) /
      (1000 * 60),
  )

  return `${minutes.toFixed()} minute${
    minutes > 1 || minutes < 1 ? 's' : ''
  } ago}`
}
